import { render, staticRenderFns } from "./HeaderBar.vue?vue&type=template&id=88e3438a&"
import script from "./HeaderBar.vue?vue&type=script&lang=js&"
export * from "./HeaderBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports